export default function elementIntersectionObserver(options) {
    const map = new Map(),
        observer = new IntersectionObserver(function(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting && map.has(entry.target)) {
                    map.get(entry.target)(entry.target);
                    map.delete(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, Object.assign({rootMargin: '320px', threshold: 0}, options || {}));

    return function(element, callback) {
        if (!element || typeof callback !== 'function') {
            throw new Error('An elementIntersectionObserver requires an element reference and a callback function');
        }

        map.set(element, callback);
        observer.observe(element);

        return observer;
    };
}
